

export enum KalturaEntryDisplayInSearchType {
    kalturaNetwork=2,
	none=0,
	partnerOnly=1,
	system=-1
}